import moneyFormatter from 'money-formatter';
import currencyList from 'currency-symbol-map';

const format = moneyFormatter.format;
const defaultOptions = {
  currencyCode: 'USD',
  useDecimals: true,
};

/**
 * Formats a Number `n` in currency style
 * @param n
 * @param [options = defaultOptions]
 * @returns {string}
 */
function currencyFormat(n, options = defaultOptions) {
  if (isNaN(parseFloat(n))) return 'NaN';

  const { currencyCode, useDecimals } = options;

  const code = (currencyList(currencyCode) === undefined || !currencyCode) ? defaultOptions.currencyCode : currencyCode;

  if (useDecimals === false) {
    const roundedValue = Math.round(n);
    if (code === 'HKD' || code === 'AUD') return format(code, roundedValue, 0).replace('$', code);

    return format(code, roundedValue, 0);
  }
  if (code === 'HKD' || code === 'AUD') return format(code, n).replace('$', code);

  return format(code, n);
}

export default currencyFormat;
